<template>
  <div>
    <SPreloader />
    <SSubHeader :pageName="'Points history'" :backButton="true"/>
    <div class="header-spacer header-spacer-small"></div>
    <md-content class="page-content">
      <md-content class="md-elevation-10 center-content">
        <div class="points-page-header">
          <PointsAreaTopBox />
        </div>
        <hr class="top-area-line" />
        <PointsPageActions
          class="actions-mobile mb-4"
          @history="changeTable('history')"
          @earned="changeTable('earned')"
          @spent="changeTable('spent')"
          @send="changeTable('send')"
        />
        <div class="md-layout page-layout-content">
          <div class="md-layout-item md-size-15 md-small-size-90">
            <PointsPageActions
              class="actions-desktop"
              @history="changeTable('history')"
              @earned="changeTable('earned')"
              @spent="changeTable('spent')"
              @send="changeTable('send')"
            />
          </div>
          <div class="md-layout-item md-size-52 md-small-size-90 max-size">
            <PointsHistoryTable :transactions="history.transactions" v-if="currentTable === 'history'" />
            <PointsEarned :history="history" v-if="currentTable === 'earned'" />
            <PointsSpent :history="history" v-if="currentTable === 'spent'" />
            <PointsSend :history="history" v-if="currentTable === 'send'"/>
            <LoadingSpinner position="relative" v-if="state === 'FETCHING'" />
          </div>
          <div
            class="md-layout-item md-size-33 md-small-size-90"
            style="text-align: -webkit-center; padding: 2rem;"
          >
            <EarnedPointsCTA v-if="currentTable === 'earned'" />
            <SpentPointsCTA v-if="currentTable === 'spent'" />
            <ReferFriendsCTA class="mt-4" />
            <SendPointsCTA
              @sendPointsCTAButton="changeTable('send')"
              class="mt-4"
              v-if="currentTable === 'earned' || currentTable === 'spent' || currentTable === 'send' || currentTable === 'history'"
            />
          </div>
        </div>
      </md-content>
    </md-content>
    <a class="back-to-top" href="#" v-if="pageBottom">
      <img src="/svg-icons/back-to-top.svg" alt="arrow" class="back-icon" />
    </a>
    <Footer/>
  </div>
</template>

<script>
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import SPreloader from "@/components/organisms/SPreloader.vue";
import PointsAreaTopBox from "@/material-components/molecules/PointsAreaTopBox.vue";
import PointsPageActions from "@/material-components/molecules/PointsPageActions.vue";
import PointsHistoryTable from "@/material-components/molecules/PointsHistoryTable.vue";
import PointsEarned from "@/material-components/molecules/PointsEarned.vue";
import PointsSpent from "@/material-components/molecules/PointsSpent.vue";
import PointsSend from "@/material-components/molecules/PointsSend.vue";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import EarnedPointsCTA from "@/material-components/atoms/EarnedPointsCTA.vue";
import SpentPointsCTA from "@/material-components/atoms/SpentPointsCTA.vue";
import ReferFriendsCTA from "@/material-components/atoms/ReferFriendsCTA.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import SendPointsCTA from "../../material-components/atoms/SendPointsCTA.vue";
import Footer from "@/templates/Footer";

export default {
  name: "PointsArea",
  data() {
    return {
      state: "FETCHING",
      history: {
        transactions: [],
        items: [],
      },
      currentTable: "",
    };
  },
  components: {
    PointsHistoryTable,
    SPreloader,
    PointsAreaTopBox,
    PointsPageActions,
    PointsEarned,
    PointsSpent,
    PointsSend,
    SSubHeader,
    EarnedPointsCTA,
    SpentPointsCTA,
    ReferFriendsCTA,
    LoadingSpinner,
    Footer,
    SendPointsCTA
},
  mixins: [UserHelperVue, ItemHelperVue],
  methods: {
    buildTransactions(transactionType) {
      this.myPoints.forEach(async (transaction) => {
        if (transaction.Trade === transactionType) {
          this.history.transactions.push({ ...transaction });
          if (transaction.ItemID && transaction.ItemID !== undefined) {
            await this.fetchItemProfile(transaction.ItemID);
            const item = { ...this.itemProfile };
            this.history.items.push({ ...item });
          }
        }
      });
    },
    async setHistory(filter) {
      this.currentTable = "";
      this.state = "FETCHING";
      this.history.transactions.length = 0;
      this.history.items.length = 0;
      await this.fetchMyPoints();
      if (filter === "history") {
        this.myPoints.forEach((transaction) => {
          this.history.transactions.push({ ...transaction });
        });
      } else if (filter === "earned") {
        this.buildTransactions("Earned")
      } else if (filter === "spent") {
        this.buildTransactions("Spent")
      }
      this.state = "LOADED";
      this.currentTable = filter;
    },
    changeTable(table) {
      localStorage.setItem("pointsSection", table);
      this.setHistory(table);
    },
  },
  created() {
    this.fetchMyPointSum();
    this.setHistory(localStorage.getItem("pointsSection"));
  },
};
</script>

<style scoped>
.points-table {
  margin-top: 3rem;
}
.center-content {
  width: 100%;
  height: 100%;
  min-height: 80vh;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 2rem;
}
.max-size {
  max-width: 49%;
}
.page-content {
  display: flex;
  justify-content: center;
  background-color: #f4f4f4;
  margin: 3rem 0;
}
.points-page-header {
  padding: 10px;
}
.top-area-line {
  margin-top: -9px;
  color: rgba(0, 0, 0, 0.12);
}
.middle-content {
  max-width: 50%;
}

.md-layout-item.md-size-33 {
  min-width: auto;
  max-width: none;
}
@media (max-width: 960px) {
  .actions-desktop {
    display: none;
  }
  .md-layout {
    justify-content: center;
  }
}
@media (min-width: 961px) {
  .actions-mobile {
    display: none;
  }
}
@media (max-width: 1024px) {
  .center-content {
    width: 85%;
    margin-bottom: 3rem;
  }
  .page-content {
    margin-top: 5rem;
  }
}

@media (min-width: 1025px) {
  .center-content {
    width: 90%;
  }
}
</style>
